import React, { FC } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Navigation } from '@ucheba/ui/components/Navigation/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { useEventsPageHeaderCore } from '../bll'

const EventsPageHeader: FC = () => {
  const { items, activeIndex, title } = useEventsPageHeaderCore()

  return (
    <>
      <Spacing spacing='xlarge' />

      <Heading h1={title} spacing='small' />

      <Navigation items={items} activeIndex={activeIndex} />
    </>
  )
}

export default EventsPageHeader
